import { render, staticRenderFns } from "./assetlist.vue?vue&type=template&id=c54f1c20"
import script from "./assetlist.vue?vue&type=script&lang=js"
export * from "./assetlist.vue?vue&type=script&lang=js"
import style0 from "./assetlist.vue?vue&type=style&index=0&id=c54f1c20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports